import React from "react";

const NoDataText = ({ columns, message }) => {
  return (
    <table className="table table-bordered">
      <thead>
        <tr>
          {columns &&
            columns.length &&
            columns.map((item) => <th key={item.text}>{item.text}</th>)}
        </tr>
      </thead>
      <tbody>
        <tr>
          <td style={{ textAlign: "center" }} colSpan={columns.length + 1}>
            {message}
          </td>
        </tr>
      </tbody>
    </table>
  );
};
export default NoDataText;
